import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const DaumAddress = () => {
  const [searchParams] = useSearchParams();

  // 파라미터 추출
  const width = searchParams.get('width');
  const height = searchParams.get('height');

  useEffect(() => {
    new window.daum.Postcode({
      width: width,
      height: height,
      onComplete: (data) => {
        const isNative = window.ReactNativeWebView;
        if (isNative)
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              data: data,
              type: 'ADDRESS',
            })
          );
      },
    }).embed();
  }, [width, height]);

  return (
    <>
      <div></div>
    </>
  );
};

export default DaumAddress;
